import styled from 'styled-components'

export const SpecificationTabWrapper = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  align-items: flex-start;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
  }
`
